import { render } from "./RecipeIngredients.vue?vue&type=template&id=fc0cc568&scoped=true&ts=true"
import script from "./RecipeIngredients.vue?vue&type=script&lang=ts"
export * from "./RecipeIngredients.vue?vue&type=script&lang=ts"

import "./RecipeIngredients.vue?vue&type=style&index=0&id=fc0cc568&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-fc0cc568"]])

export default __exports__